import { BaseModel } from '@red/data-access';
import { Expose } from 'class-transformer';
import { ITransactionStatusHistory } from '@shared/data-access/interfaces/transaction-status-history.interface';
import { MANAGEMENT_COMMISSION_STATUSES } from '../data/management-commission.data';
import { ManagementCommissionStatusRecord } from '../types/management-commission.type';
import { EManagementCommissionStatus } from '../enums/management-commission.enum';

export class TransactionStatusHistoryModel extends BaseModel implements ITransactionStatusHistory {
  @Expose()
  id!: number;

  @Expose()
  action!: EManagementCommissionStatus;

  @Expose()
  createdAt!: string;

  @Expose()
  createdBy!: string;

  @Expose()
  data!: any;

  @Expose()
  deletedAt!: string;

  @Expose()
  deletedBy!: string;

  @Expose()
  sourceId!: number;

  @Expose()
  type!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  updatedBy!: string;

  @Expose()
  get statusDisplay() {
    return MANAGEMENT_COMMISSION_STATUSES[this.action as EManagementCommissionStatus];
  }
}
